import { Input, Stack } from '@mui/material';

import QuickStartErrorText from '../common/errorText';

interface FullNameTextFieldProps {
  value: string;
  setValue: (value: string) => void;
  error: string;
}

const FullNameTextField = ({ value, setValue, error }: FullNameTextFieldProps) => {

  return (
    <Stack flexGrow={1}>
      <Input
        id="companyName"
        name="companyName"
        disableUnderline
        fullWidth
        sx={{
          border: '1px solid #D1D1D1',
          borderRadius: '6px',
          padding:'10px 16px',
          '& .MuiInputBase-input': {
            fontFamily:'Schibsted Grotesk, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            color: '#181818',
            lineHeight: '125%',
          },
          '&:focus-within': {
            border: '1px solid #000000',
          },
        }}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      {error !== '' && <QuickStartErrorText error={error} />}
    </Stack>
  );
};

export default FullNameTextField;